/* eslint-disable max-len */
import type { FC } from "react";

import type { IconProps } from "./BaseIcon";
import { BaseIcon } from "./BaseIcon";

export const BarChartIcon: FC<IconProps> = (props) => {
  return (
    <BaseIcon {...props}>
      <path
        d="M27 4C27.5177 4 27.9438 4.39333 27.9951 4.89746C27.9985 4.93116 28 4.96539 28 5V25H29C29.5523 25 30 25.4477 30 26C30 26.5523 29.5523 27 29 27H4C3.96539 27 3.93116 26.9985 3.89746 26.9951C3.39333 26.9438 3 26.5177 3 26C3 25.4477 3.44772 25 4 25H5V17C5 16.4477 5.44772 16 6 16H12V11C12 10.9654 12.0015 10.9312 12.0049 10.8975C12.0562 10.3933 12.4823 10 13 10H19V5C19 4.96539 19.0015 4.93116 19.0049 4.89746C19.0562 4.39333 19.4823 4 20 4H27ZM7 25H12V18H7V25ZM14 25H19V12H14V25ZM21 25H26V6H21V25Z"
      />
    </BaseIcon>
  );
};

